jQuery(document).ready(function ($) {
    'use strict';

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    var blocs = document.querySelectorAll('.bloc_liens');

    if (!blocs.length) {
        return;
    }

    var DEBUT = 'top 90%';
    var FIN = 'top 50%';
    var SCRUB = .8;

    var DISTANCE = 180;
    var DUREE = .5;
    var DECALAGE = 0.15;

    /* Un mouvement pilote par le scroll se lit mieux sans acceleration :
       l'ease du socle (power3.out) donnerait des variations de vitesse
       sans rapport avec le geste de la molette. */
    var EASE = 'power1.out';

    var TRANSITION_CONSERVEE = 'background-color 150ms ease-in-out';

    Array.prototype.forEach.call(blocs, function (bloc) {
        var cartes = bloc.querySelectorAll('.liens .lien');

        if (!cartes.length) {
            return;
        }

        Array.prototype.forEach.call(cartes, function (carte) {
            carte.style.transition = TRANSITION_CONSERVEE;
        });

        gsap.set(cartes, {y: DISTANCE});

        gsap.to(cartes, {
            y: 0,
            duration: DUREE,
            stagger: DECALAGE,
            ease: EASE,
            scrollTrigger: {
                trigger: bloc,
                start: DEBUT,
                end: FIN,
                scrub: SCRUB
            }
        });
    });
});
